import Supporters from "../api/Supporters";

export const fetchSupporter = (contactID) => (dispatch) => {
  dispatch({ type: "SET_CONTACT_MODAL_LOADING", loading: true });
  Supporters.getOne(contactID)
    .then((response) => {
      dispatch({
        type: "SET_CONTACT_MODAL_DETAILS",
        contactDetails: { ...response.data },
      });
      dispatch({ type: "ADD_CONTACT", contact: { ...response.data } });
      dispatch({ type: "SET_CONTACT_MODAL_LOADING", loading: false });
    })
    .catch((e) => {
      dispatch({ type: "SET_CONTACT_MODAL_LOADING", loading: false });
      dispatch({ type: "SET_ERROR_SUPPORTER", error: true });
      throw new Error(e);
    });
};

export const setTableError = (error) => (dispatch) =>
  dispatch({ type: "SET_TABLE_ERROR", error });
export const setTableLoading = (loading) => (dispatch) =>
  dispatch({ type: "SET_TABLE_LOADING", loading });
export const setTableLoadingMore = (loadingMore) => (dispatch) =>
  dispatch({ type: "SET_TABLE_LOADING_MORE", loadingMore });
export const setTable404 = (is404) => (dispatch) =>
  dispatch({ type: "SET_TABLE_404", is404 });

let controller = new AbortController();
export const fetchSupporters =
  (reportType, programmeID, sorting, searchQuery, page) => (dispatch) => {
    if (!page) {
      controller.abort();
    }
    controller = new AbortController();
    return Supporters.getMany(
      controller.signal,
      reportType,
      programmeID,
      sorting,
      searchQuery,
      page
    )
      .then((response) => {
        dispatch(setTableError(""));
        dispatch(setTableLoading(false));
        dispatch(setTableLoadingMore(false));

        // workaround - getting inconsistant data from API controller...
        if (!response.data.meta) {
          const { data, ...meta } = response.data;
          return {
            data,
            meta,
          };
        }
        return response.data;
      })
      .catch((error) => {
        console.error(error);
        if (error === "Response was cancelled") {
          return false;
        }

        dispatch(setTableLoading(false));
        dispatch(setTableLoadingMore(false));

        if (
          error.errors &&
          error.errors[0] === "No matching records found" &&
          page
        ) {
          dispatch(setTable404(true));
          return false;
        }
        dispatch(
          setTableError(
            error.errors ? error.errors[0] : "Something went wrong."
          )
        );
        return [];
      });
  };

export const setModalContactDetails = (contactDetails) => (dispatch) => {
  dispatch({ type: "SET_CONTACT_MODAL_DETAILS", contactDetails });
  dispatch({ type: "SET_CONTACT_MODAL_LOADING", loading: false });
};

export const setContactDetailsModalOpen =
  (contactID, canEdit) => (dispatch) => {
    dispatch({ type: "SET_CONTACT_MODAL_ID", contactID });
    dispatch({ type: "SET_CONTACT_MODAL_CAN_EDIT", canEdit });
    dispatch({ type: "SET_CONTACT_MODAL_IS_OPEN", isOpen: true });
  };

export const setChangesModalData = (data, fullname, isOpen) => (dispatch) => {
  dispatch({ type: "SET_CHANGES_MODAL_DATA", data });
  dispatch({ type: "SET_CHANGES_MODAL_NAME", fullname });
  dispatch({ type: "SET_CHANGES_MODAL_IS_OPEN", isOpen });
};

export const setContactDetailsModalClosed = () => (dispatch) => {
  dispatch({ type: "SET_CONTACT_MODAL_LOADING", loading: true });
  dispatch({ type: "SET_CONTACT_MODAL_ERROR", error: false });
  dispatch({ type: "SET_CONTACT_MODAL_ID", contactID: null });
  dispatch({ type: "SET_CONTACT_MODAL_DETAILS", contactDetails: null });
  dispatch({ type: "SET_CONTACT_MODAL_IS_OPEN", isOpen: false });
};
